/**
 * ROSTER AGGREGATOR — every roster-wave region in one array.
 * Generated by scripts/assemble-roster.mjs.
 */
import type { Location } from "../types";
import { ROSTER_AIRDRIE_CORRIDOR } from "./airdrie-corridor";
import { ROSTER_BANFF_AREA } from "./banff-area";
import { ROSTER_BOW_VALLEY } from "./bow-valley";
import { ROSTER_CALGARY_CENTRE } from "./calgary-centre";
import { ROSTER_CALGARY_NE } from "./calgary-ne";
import { ROSTER_CALGARY_NW } from "./calgary-nw";
import { ROSTER_CALGARY_SE } from "./calgary-se";
import { ROSTER_CALGARY_SW } from "./calgary-sw";
import { ROSTER_CHESTERMERE_AREA } from "./chestermere-area";
import { ROSTER_COCHRANE_FOOTHILLS } from "./cochrane-foothills";
import { ROSTER_COCHRANE_WEST } from "./cochrane-west";
import { ROSTER_FOOTHILLS_SOUTH } from "./foothills-south";
import { ROSTER_QE2_CORRIDOR } from "./qe2-corridor";
import { ROSTER_ROCKY_VIEW } from "./rocky-view";
import { ROSTER_ROCKY_VIEW_EAST } from "./rocky-view-east";
import { ROSTER_WHEATLAND } from "./wheatland";

export const ROSTER_LOCATIONS: Location[] = [
  ...ROSTER_AIRDRIE_CORRIDOR,
  ...ROSTER_BANFF_AREA,
  ...ROSTER_BOW_VALLEY,
  ...ROSTER_CALGARY_CENTRE,
  ...ROSTER_CALGARY_NE,
  ...ROSTER_CALGARY_NW,
  ...ROSTER_CALGARY_SE,
  ...ROSTER_CALGARY_SW,
  ...ROSTER_CHESTERMERE_AREA,
  ...ROSTER_COCHRANE_FOOTHILLS,
  ...ROSTER_COCHRANE_WEST,
  ...ROSTER_FOOTHILLS_SOUTH,
  ...ROSTER_QE2_CORRIDOR,
  ...ROSTER_ROCKY_VIEW,
  ...ROSTER_ROCKY_VIEW_EAST,
  ...ROSTER_WHEATLAND,
];
